import React from 'react';
import { useTranslation } from 'react-i18next';
import PitchBreakChart from './PitchBreakChart';
import PitchBreakTable from './PitchBreakTable';
import ReportCard from '../../../../components/ReportCard';

const PitchBreak = ({ isLoading, isVsBatter, zScoreData, pitches, pitchCharacteristics, throws,
    pitcherId, yearId, isLhb, isLhp, levelId, lgavgkzon, repertoire }) => {
    const { t: translate } = useTranslation();

    return (
        <ReportCard
            title={`${translate('pitcher-overview.sections.pitch-break')} 
                    ${translate('baseball.abbr-versus')} ${isLhb ? translate('baseball.lhh') : translate('baseball.rhh')}
                    ${isVsBatter ? `(${translate('common.projected')})` : ''}`}
        >
            {pitches.length ? (
                <div className="d-flex align-items-center flex-wrap">
                    <div>
                        <PitchBreakChart
                            pitches={pitches}
                            pitchCharacteristics={pitchCharacteristics}
                            throws={throws}
                            pitcherId={pitcherId}
                            yearId={yearId}
                            repertoire={repertoire}
                        />
                    </div>
                    <div className="flex-grow-1 ps-2">
                        <PitchBreakTable
                            isLhb={isLhb}
                            isLhp={isLhp}
                            levelId={levelId}
                            lgavgkzon={lgavgkzon}
                            pitches={pitches}
                            pitchCharacteristics={pitchCharacteristics}
                            repertoire={repertoire}
                            throws={throws}
                            pitcherId={pitcherId}
                            yearId={yearId}
                            isLoading={isLoading}
                            zScoreData={zScoreData}
                        />
                    </div>
                </div>
            ) : <div className="d-flex justify-content-center py-5 text-muted">{translate('pitcher-overview.no-data')}</div>}
        </ReportCard>
    );
};

export default PitchBreak;
